import { useState, useEffect } from 'react';

export interface Vehicle {
  id: string | number;
  name: string;
  capacity: number;
  type?: string;
  valhallaConfig?: any;
  // Araç Özel Parametreler
  skills?: number[];                  // Aracın sahip olduğu yetenekler (integer array)
  speed_factor?: number;              // Hız faktörü (0.5-1.5 arası, 1.0 = normal)
}

export const useVehicleManagement = () => {
  const [allVehicles, setAllVehicles] = useState<Vehicle[]>([]);
  const [selectedVehicles, setSelectedVehicles] = useState<Vehicle[]>([]);

  useEffect(() => {
    loadVehicles();
  }, []);

  const loadVehicles = async () => {
    try {
      const response = await fetch('/vehicles.json');
      if (response.ok) {
        const data = await response.json();
        if (data.vehicles && data.vehicles.length > 0) {
          setAllVehicles(data.vehicles);
          console.log(`✅ ${data.vehicles.length} araç yüklendi`);
        }
      } else {
        console.error('❌ Araç yükleme hatası: HTTP', response.status);
      }
    } catch (error) {
      console.error('❌ Araç yükleme hatası:', error);
    }
  };

  const toggleVehicle = (vehicle: Vehicle) => {
    const isSelected = selectedVehicles.some(v => v.id === vehicle.id);
    setSelectedVehicles(prev =>
      isSelected ? prev.filter(v => v.id !== vehicle.id) : [...prev, vehicle]
    );
  };

  const selectAllVehicles = () => {
    setSelectedVehicles([...allVehicles]);
  };

  const clearSelectedVehicles = () => {
    setSelectedVehicles([]);
  };

  const getTotalCapacity = () => {
    return selectedVehicles.reduce((sum, v) => sum + (v.capacity || 0), 0);
  };

  return {
    allVehicles,
    selectedVehicles,
    setSelectedVehicles,
    toggleVehicle,
    selectAllVehicles,
    clearSelectedVehicles,
    getTotalCapacity
  };
};
